import {
  Box,
  Avatar,
  AvatarGroup,
  CircularProgress,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import CircularTMSLoader from '../../TmsLoader/TmsLoader';
import { Tooltip } from '@mui/material';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import {
  AddUpdateLocation,
  GetAgencyLocations,
  GetCarriers,
  GetLocationCarriers,
  SetAsDefaultLocation,
  UpdateShipmentLocation
} from '../../apis/Agency';
import { useSelector } from 'react-redux';
import {
  useHistory,
  useLocation
} from 'react-router-dom/cjs/react-router-dom.min';
import {
  MaterialReactTable,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleFiltersButton,
  MRT_FullScreenToggleButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import './CreateUser.css';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import { ErrorToast, successToast } from '../../components/Toasts';
import { ToastContainer } from 'react-toastify';
import { base_logo_url, base_url } from '../../apis/constants';
import { MetaTags } from 'react-meta-tags';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';

function Locations(props) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderNumber = searchParams.get('shipmentId');

  const [shipmentsLoader, setShipmentsLoader] = useState(true);
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const history = useHistory();
  const [agencyLocationsArray, setAgencyLocationsArray] = useState([]);
  const [shipCity, setShipCity] = useState([]);
  const [carriers, setCarriers] = useState([]);
  const [userPermissionsArr, setUserPermissionsArr] = useState(null);
  const [assignLocLoader, setAssignLocLoader] = useState(false);
  const [assignLocIndex, setAssignLocIndex] = useState(null);
  const [filteredLocation, setFilteredLocation] = useState('');
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);
  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );
  const params = new URLSearchParams(location.search);
  const decodedLocation = decodeURIComponent(params.get('location'));
  const locationTab = params.get('tab');

  const [settingDefault, setSettingDefault] = useState(-1);
  const [defaultConfirmDialog, setDefaultConfirmDialog] = useState(false);
  const [locationToDefault, setLocationToDefault] = useState({
    name: '',
    id: 0
  });

  // Clone Location States
  const [cloneDialogOpen, setCloneDialogOpen] = useState(false);
  const [selectedLocationToClone, setSelectedLocationToClone] = useState('');
  const [cloneLocationLoader, setCloneLocationLoader] = useState(false);
  const [cloneLocationData, setCloneLocationData] = useState(null);

  // Get the value of shipmentId parameter

  const handleClose = () => {
    setDefaultConfirmDialog(false);
  };

  const handleCloseCloneDialog = () => {
    setCloneDialogOpen(false);
    setSelectedLocationToClone('');
    setCloneLocationData(null);
  };

  const mncolumns = [
    {
      accessorKey: 'name',
      id: 'name',
      header: 'Location Name',
      size: 10,
      Cell: ({ cell, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span class='mx-1'>{cell.getValue()}</span>
          </Box>
          {!isMobile &&
            ((userPermissionsArr &&
              userPermissionsArr.filter(permissions => permissions.level4)
                .length) ||
              userPermissionsArr.filter(permissions => permissions.level2)
                .length ||
              UserIsAdmin) && (
              <div
                className={isMobile ? '' : 'table-row-buttons-users py-2'}
                style={{ marginLeft: '-2.5vw' }}
              >
                <button
                  onClick={event => handleUpdateLocation(row.original)}
                  class=' bg-white border-0 p-2 fw-bold'
                  style={{
                    color: '#3361FF',
                    borderRadius: '4px',
                    marginTop: 5
                  }}
                >
                  <Tooltip title='View / Update'>
                    <svg
                      className='MX-1'
                      width='17'
                      height='17'
                      viewBox='0 0 13 13'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1.33333 11.1693H2.26667L8.01667 5.41927L7.08333 4.48594L1.33333 10.2359V11.1693ZM10.8667 4.4526L8.03333 1.6526L8.96667 0.719271C9.22222 0.463715 9.53611 0.335938 9.90833 0.335938C10.2806 0.335938 10.5944 0.463715 10.85 0.719271L11.7833 1.6526C12.0389 1.90816 12.1722 2.21649 12.1833 2.5776C12.1944 2.93872 12.0722 3.24705 11.8167 3.5026L10.8667 4.4526ZM9.9 5.43594L2.83333 12.5026H0V9.66927L7.06667 2.6026L9.9 5.43594Z'
                        fill='#3361FF'
                      />
                    </svg>
                  </Tooltip>
                </button>
                {props?.location?.state?.shipmentId &&
                  (assignLocLoader && assignLocIndex === row.index ? (
                    <Box sx={{ display: 'inline-flex', mx: 1, mb: -0.6 }}>
                      <CircularTMSLoader size={60} variant='progress' />
                    </Box>
                  ) : (
                    <button
                      onClick={event =>
                        handleOpenAddUpdateLocReq(row.original, row)
                      }
                      class=' bg-white border-0 p-1 fw-bold mx-2'
                      style={{ color: '#3361FF', borderRadius: '4px' }}
                    >
                      <Tooltip title='Assign Location'>
                        <AddLocationIcon />
                      </Tooltip>
                    </button>
                  ))}
              </div>
            )}
        </>
      )
    },
    {
      accessorKey: 'streetLines',
      id: 'streetLines',
      header: 'Street Lines',
      size: 70,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return (
          <Tooltip title={value || ''}>
            <Box
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: 200,
                cursor: 'default'
              }}
            >
              {value}
            </Box>
          </Tooltip>
        );
      }
    },
    {
      accessorKey: 'city',
      id: 'city',
      header: 'City/State/Zip/Country',
      size: 70,
      Cell: ({ cell, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span class='mx-1'>
              {row.original.city +
                ' ' +
                row.original.state +
                ' ' +
                row.original.postalCode +
                ' ' +
                row.original.countryCode}
            </span>
          </Box>
        </>
      )
    },
    {
      accessorKey: 'isDefault',
      id: 'isDefault',
      header: 'Default',
      size: 70,
      Cell: ({ cell, row }) => (
        <>
          {settingDefault === row.original.id ? (
            <Box className='ms-2' sx={{ display: 'inline-flex' }}>
              <CircularTMSLoader size={60} variant='progress' />
            </Box>
          ) : (
            <Checkbox
              checked={cell.getValue()}
              disabled={settingDefault !== -1}
              onChange={e => {
                if (e.target.checked) {
                  setLocationToDefault({
                    name: row.original.name,
                    id: row.original.id
                  });
                  setDefaultConfirmDialog(true);
                }
              }}
            />
          )}
        </>
      )
    },
    {
      accessorKey: 'isHome',
      id: 'isHome',
      header: 'Home',
      size: 70,
      Cell: ({ cell, row }) => (
        <>
          <Checkbox
            checked={cell.getValue()}
            disabled={settingDefault !== -1}
            onClick={e =>
              handleAddUpdateLocation(row.original, e.target.checked)
            }
          />
        </>
      )
    },
    {
      accessorKey: 'active',
      id: 'active',
      header: 'Location Status',
      size: 70,
      Cell: ({ cell }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {cell.getValue() ? (
              <span class='mx-1 text-success'>
                ACTIVE{' '}
                <svg
                  width='18'
                  height='18'
                  viewBox='0 0 18 18'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M8.99719 4.3725L11.3747 6.75L12.4322 5.6925L8.99719 2.25L5.55469 5.6925L6.61969 6.75L8.99719 4.3725ZM8.99719 13.6275L6.61969 11.25L5.56219 12.3075L8.99719 15.75L12.4397 12.3075L11.3747 11.25L8.99719 13.6275Z'
                    fill='#2E7D32'
                  />
                </svg>
              </span>
            ) : (
              <span class='mx-1 text-muted'>
                INACTIVE{' '}
                <svg
                  width='18'
                  height='18'
                  viewBox='0 0 18 18'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M8.99719 4.3725L11.3747 6.75L12.4322 5.6925L8.99719 2.25L5.55469 5.6925L6.61969 6.75L8.99719 4.3725ZM8.99719 13.6275L6.61969 11.25L5.56219 12.3075L8.99719 15.75L12.4397 12.3075L11.3747 11.25L8.99719 13.6275Z'
                    fill='black'
                    fill-opacity='0.6'
                  />
                </svg>
              </span>
            )}
          </Box>
        </>
      )
    }
  ];
  const [tableColumns, setTableColumns] = useState(mncolumns);

  useEffect(() => {
    let tempMncolumns = [...mncolumns];
    if (
      userPermissionsArr &&
      !userPermissionsArr.filter(permissions => permissions.level5).length &&
      !UserIsAdmin
    ) {
      tempMncolumns = tempMncolumns.filter(col => {
        return col.accessorKey !== 'isDefault';
      });
    }

    if (
      userPermissionsArr &&
      !userPermissionsArr.filter(permissions => permissions.level6).length &&
      !UserIsAdmin
    ) {
      tempMncolumns = tempMncolumns.filter(col => {
        return col.accessorKey !== 'isHome';
      });
    }
    setTableColumns(tempMncolumns);
  }, [userPermissionsArr]);

  useEffect(() => {
    if (decodedLocation && decodedLocation !== 'null') {
      const splitedLocName = decodedLocation.split(': ');
      const splitedTabName = decodedLocation.split('?');

      const filteredTableLoc = agencyLocationsArray.filter(
        loc => loc.name === splitedLocName[0]
      );
      console.log(splitedTabName[1], 'splitedTabName');
      if (filteredTableLoc.length > 0) {
        handleUpdateLocation(
          filteredTableLoc[0],
          'quickQoute',
          splitedTabName[1]
        );
      }
    }
  }, [decodedLocation, agencyLocationsArray]);
  const isMobile = useIsMobile();

  useEffect(() => {
    const filteredCarrierPermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Locations'
    );
    setUserPermissionsArr(filteredCarrierPermissions);
  }, [userRolePermissions]);

  const handleSuccesGetCarriers = ApiRes => {
    const CarrierArray = ApiRes?.data?.data.filter(items => items.active);
    const Temp = [];
    for (let index = 0; index < CarrierArray.length; index++) {
      const CarrierName = CarrierArray[index].name;
      Temp.push(CarrierName);
    }
    setCarriers(CarrierArray);
  };

  const handleSuccessAgencyLocations = res => {
    setShipmentsLoader(false);
    setAgencyLocationsArray(res?.data?.data.reverse());
  };

  const handleErrorAgencyLocations = err => {
    setShipmentsLoader(false);
  };

  const fetchLocations = () => {
    setShipmentsLoader(true);
    GetAgencyLocations(AgencyID, 0)
      .then(res => res.status === 200 && handleSuccessAgencyLocations(res))
      .catch(err => handleErrorAgencyLocations(err));
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  const handleUpdateLocation = (data, type, tab) => {
    GetLocationCarriers(AgencyID, data.id)
      .then(
        res =>
          res.status === 200 &&
          history.push({
            pathname: '/add-locations',
            state: {
              data: { ...data, locationCarriers: res.data.data },
              type,
              tab
            }
          })
      )
      .catch(err => {
        ErrorToast(`GetLocationCarriers API failed due to ${err?.message}`);
        console.log(err, 'locaion carriers error');
      });
  };

  const handleOpenAddUpdateLocReq = (rowData, row) => {
    setAssignLocIndex(row.index);
    setAssignLocLoader(true);
    const locatioObj = {
      shipmentId: parseInt(props?.location?.state?.shipmentId),
      locationId: rowData?.id
    };

    UpdateShipmentLocation(locatioObj)
      .then(res => {
        res.status === 200 && setAssignLocLoader(false);
        successToast('Location Updated Successfully!');
        setTimeout(() => {
          history.push({
            pathname: '/manage-shipments'
          });
        }, 1000);
      })
      .catch(err => {
        setAssignLocLoader(false);
        ErrorToast(err?.message);
      });
  };

  const handleLocationDefault = rId => {
    setDefaultConfirmDialog(false);
    setSettingDefault(rId);

    SetAsDefaultLocation(rId)
      .then(res => {
        setSettingDefault(-1);
        fetchLocations();

        successToast('Location Updated Successfully!');
      })
      .catch(err => {
        console.log(err, 'setSettingDefault');
        ErrorToast('Location Update failed');
      });
  };

  const handleAddUpdateLocation = (rowDate, isHomeValue) => {
    const locationObj = {
      id: rowDate?.id ? rowDate?.id : 0,
      agencyId: AgencyID,
      name: rowDate?.name,
      streetLines: rowDate?.streetLines,
      city: rowDate?.city,
      countryCode: rowDate?.countryCode,
      state: rowDate?.state,
      postalCode: rowDate?.postalCode,
      active: rowDate.active,
      contactName: rowDate?.contactName,
      contactEmail: rowDate?.contactEmail,
      contactPhone: rowDate?.contactPhone,
      companyName: rowDate?.companyName,
      cuttOffTime: rowDate?.cuttOffTime,
      isHome: isHomeValue,
      isDefault: rowDate?.isDefault
    };

    AddUpdateLocation(locationObj)
      .then(res => {
        res.status === 200 &&
          successToast(
            <span>
              The location <strong>{rowDate?.name}</strong> has been
              successfully
              {!isHomeValue ? ' removed from' : ' set as your'} home location!
            </span>
          );
        fetchLocations();
      })
      .catch(err =>
        ErrorToast(
          err?.response?.data?.reasonPhrase
            ? err?.response?.data?.reasonPhrase
            : err?.message
        )
      );
  };

  // Clone Location Functions
  const handleOpenCloneDialog = () => {
    setCloneDialogOpen(true);
  };

  const handleLocationSelectChange = event => {
    const locationId = event.target.value;
    setSelectedLocationToClone(locationId);

    // Find the selected location data
    const selectedLocation = agencyLocationsArray.find(
      loc => loc.id === locationId
    );
    if (selectedLocation) {
      setCloneLocationData(selectedLocation);
    }
  };

  const handleCloneLocation = () => {
    if (!selectedLocationToClone || !cloneLocationData) {
      ErrorToast('Please select a location to clone');
      return;
    }

    setCloneLocationLoader(true);

    // First, get the carriers for the selected location
    GetLocationCarriers(AgencyID, selectedLocationToClone)
      .then(res => {
        if (res.status === 200) {
          // Prepare the cloned location data
          const clonedData = {
            ...cloneLocationData,
            id: 0, // Reset ID for new location
            name: `${cloneLocationData.name} - Copy`, // Suggest a new name
            locationCarriers: res.data.data,
            isDefault: false, // Cloned location shouldn't be default
            isHome: false // Cloned location shouldn't be home
          };

          // Navigate to add-locations page with cloned data
          // history.push({
          //   pathname: '/add-locations',
          //   state: {
          //     data: clonedData,
          //     type: 'clone',
          //     tab: null
          //   }
          // });

          history.push({
            pathname: '/add-locations',
            state: {
              data: { ...cloneLocationData, locationCarriers: res.data.data },
              type: 'clone',
              tab: null
            }
          });

          setCloneLocationLoader(false);
          handleCloseCloneDialog();
        }
      })
      .catch(err => {
        setCloneLocationLoader(false);
        ErrorToast(`Failed to fetch location carriers: ${err?.message}`);
      });
  };

  return (
    <div class='mt-2 mx-3' style={{ border: '' }}>
      <MetaTags>
        <title>
          {' '}
          {base_url === 'https://beta.api.shiptechpro.com/'
            ? 'Locations | Shiptechpro'
            : 'Locations | TMS Shipping'}
        </title>
      </MetaTags>
      <ToastContainer
        style={
          isMobile
            ? { width: '100%', display: 'flex', justifyContent: 'center' }
            : { width: 'auto' }
        }
        position='top-center'
        autoClose={6800}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* Default Location Confirmation Dialog */}
      <Dialog
        open={defaultConfirmDialog}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogContent sx={{ minWidth: '400px' }}>
          <DialogContentText id='alert-dialog-description'>
            Are you sure to set{' '}
            <b className='text-black'>'{locationToDefault.name}'</b> location as
            default?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={handleClose} size='small'>
            Cancel
          </Button>
          <Button
            variant='contained'
            size='small'
            onClick={() => handleLocationDefault(locationToDefault.id)}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Clone Location Dialog */}
      <Dialog
        open={cloneDialogOpen}
        onClose={handleCloseCloneDialog}
        aria-labelledby='clone-location-dialog-title'
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle id='clone-location-dialog-title'>
          Clone Location
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText className='mb-3'>
            Select a location to clone. All details will be copied except the
            location name, which you can edit in the next step.
          </DialogContentText> */}

          <FormControl fullWidth variant='outlined' size='small' sx={{ mt: 1 }}>
            <InputLabel id='select-location-label'>Select Location</InputLabel>
            <Select
              labelId='select-location-label'
              id='select-location'
              value={selectedLocationToClone}
              onChange={handleLocationSelectChange}
              label='Select Location'
            >
              <MenuItem value=''>
                <em>Select a location</em>
              </MenuItem>
              {agencyLocationsArray.map(location => (
                <MenuItem key={location.id} value={location.id}>
                  {location.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {cloneLocationData && (
            <Box
              sx={{ mt: 2, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}
            >
              <DialogContentText variant='subtitle2' className='mb-1'>
                Selected Location:
              </DialogContentText>
              <DialogContentText variant='body2'>
                <strong>Name:</strong> {cloneLocationData.name}
                {/* <br />
                <strong>Address:</strong> {cloneLocationData.streetLines},{' '}
                {cloneLocationData.city}, {cloneLocationData.state}{' '}
                {cloneLocationData.postalCode}
                <br />
                <strong>Contact:</strong> {cloneLocationData.contactName} (
                {cloneLocationData.contactEmail}) */}
              </DialogContentText>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant='outlined'
            onClick={handleCloseCloneDialog}
            size='small'
            disabled={cloneLocationLoader}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            size='small'
            onClick={handleCloneLocation}
            disabled={!selectedLocationToClone || cloneLocationLoader}
          >
            {cloneLocationLoader ? (
              <CircularProgress size={20} color='inherit' />
            ) : (
              'Clone'
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <MaterialReactTable
        enableRowActions={isMobile ? true : false}
        renderRowActions={({ table, row }) =>
          ((userPermissionsArr &&
            userPermissionsArr.filter(permissions => permissions.level4)
              .length) ||
            userPermissionsArr.filter(permissions => permissions.level2)
              .length ||
            UserIsAdmin) && (
            <div>
              <button
                onClick={event => handleUpdateLocation(row.original)}
                class=' border-0 p-2 fw-bold'
                style={{
                  color: '#3361FF',
                  borderRadius: '4px',
                  marginTop: 5
                }}
              >
                <Tooltip title='View / Update'>
                  <svg
                    className='MX-1'
                    width='17'
                    height='17'
                    viewBox='0 0 13 13'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M1.33333 11.1693H2.26667L8.01667 5.41927L7.08333 4.48594L1.33333 10.2359V11.1693ZM10.8667 4.4526L8.03333 1.6526L8.96667 0.719271C9.22222 0.463715 9.53611 0.335938 9.90833 0.335938C10.2806 0.335938 10.5944 0.463715 10.85 0.719271L11.7833 1.6526C12.0389 1.90816 12.1722 2.21649 12.1833 2.5776C12.1944 2.93872 12.0722 3.24705 11.8167 3.5026L10.8667 4.4526ZM9.9 5.43594L2.83333 12.5026H0V9.66927L7.06667 2.6026L9.9 5.43594Z'
                      fill='#3361FF'
                    />
                  </svg>
                </Tooltip>
              </button>
              {props?.location?.state?.shipmentId &&
                (assignLocLoader && assignLocIndex === row.index ? (
                  <Box sx={{ display: 'inline-flex', mx: 1, mb: -0.6 }}>
                    <CircularTMSLoader size={60} variant='progress' />
                  </Box>
                ) : (
                  <button
                    onClick={event =>
                      handleOpenAddUpdateLocReq(row.original, row)
                    }
                    class=' bg-white border-0 p-1 fw-bold mx-2'
                    style={{ color: '#3361FF', borderRadius: '4px' }}
                  >
                    <Tooltip title='Assign Location'>
                      <AddLocationIcon />
                    </Tooltip>
                  </button>
                ))}
            </div>
          )
        }
        state={{ isLoading: shipmentsLoader }}
        columns={tableColumns}
        data={agencyLocationsArray}
        enableRowSelection
        muiTableBodyRowProps={({ row }) => ({})}
        muiTableHeadCellFilterTextFieldProps={{ placeholder: '' }}
        muiTableContainerProps={{
          sx: { maxHeight: '70vh', minHeight: '70vh', mb: 0 }
        }}
        initialState={{
          density: 'compact'
        }}
        positionToolbarAlertBanner='bottom'
        renderToolbarInternalActions={({ table }) => (
          <div>
            <MRT_ToggleGlobalFilterButton table={table} title='Search' />

            <IconButton title='Print'>
              <LocalPrintshopOutlinedIcon />
            </IconButton>

            <MRT_ToggleFiltersButton table={table} title='Filters' />

            <MRT_ToggleDensePaddingButton table={table} title='Spacing' />
            <MRT_ShowHideColumnsButton
              table={table}
              title='Show/Hide Columns'
            />
            <MRT_FullScreenToggleButton table={table} title='Fullscreen' />
            <Tooltip title='Clear All Filters' arrow>
              <IconButton
                onClick={() => {
                  table.resetColumnFilters(true);
                  table.setShowColumnFilters(false);
                }}
              >
                <FilterAltOffIcon />
              </IconButton>
            </Tooltip>
          </div>
        )}
        renderTopToolbarCustomActions={({ table }) => {
          if (
            (userPermissionsArr &&
              userPermissionsArr.filter(permissions => permissions.level3)
                .length) ||
            UserIsAdmin
          ) {
            return (
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <Button
                  onClick={() =>
                    props?.location?.state?.shipmentId
                      ? history.push({
                          pathname: '/add-locations',
                          search: `?shipmentId=${orderNumber}`
                        })
                      : history.push('/add-locations')
                  }
                  className='m-2'
                  style={
                    isMobile
                      ? {
                          fontSize: 10,
                          color: '#3361FF',
                          backgroundColor: '#E4F3FD'
                        }
                      : { color: '#3361FF', backgroundColor: '#E4F3FD' }
                  }
                  variant='contained'
                >
                  ADD{' '}
                  <svg
                    className='ms-2'
                    width='11'
                    height='10'
                    viewBox='0 0 11 10'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M4.94531 9.72396V5.72396H0.945312V4.39062H4.94531V0.390625H6.27865V4.39062H10.2786V5.72396H6.27865V9.72396H4.94531Z'
                      fill='#3361FF'
                    />
                  </svg>
                </Button>

                {/* <Button
                  onClick={handleOpenCloneDialog}
                  className='m-2'
                  style={
                    isMobile
                      ? {
                          fontSize: 10,
                          color: '#3361FF',
                          backgroundColor: '#E4F3FD'
                        }
                      : { color: '#3361FF', backgroundColor: '#E4F3FD' }
                  }
                  variant='contained'
                >
                  Clone Location
                </Button> */}
              </div>
            );
          }
        }}
      />
    </div>
  );
}

export default Locations;
